// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Fdpr","inputWrap":"styles_inputWrap__1Pt7w","input":"styles_input__1R3Xn"};